/* SPACES wall preview: the room surfaces drawn to scale (white ceiling, light grey side walls, parquet floor),
   the wall with rulers, dimension lines, optional 58 cm strips, and zoom / pan. */
(function () {
  var STRIP = 58, COVER = 57;
  function el(s, r) { return (r || document).querySelector(s); }
  function steps(W) { var c = [10, 25, 50, 100, 200, 500], i; for (i = 0; i < c.length; i++) { if (W / c[i] <= 8) return c[i]; } return 500; }
  function lab(v) { return v >= 100 && v % 100 === 0 ? (v / 100) + ' m' : v + ' cm'; }
  function pt(a, b) { return a + ',' + b; }

  // the room around the wall: ceiling, side walls, parquet floor (perspective from the wall corners to the corners of the view)
  function room(svg, cw, ch, L, T, R, B, W) {
    var f = function (n) { return n.toFixed(1); };
    var out = '<defs><linearGradient id="spFl" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#dcb987"/><stop offset="1" stop-color="#c39b65"/></linearGradient>' +
      '<linearGradient id="spSw" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#ececec"/><stop offset="1" stop-color="#f3f3f3"/></linearGradient></defs>';
    out += '<polygon points="' + [pt(0, 0), pt(cw, 0), pt(R, T), pt(L, T)].join(' ') + '" fill="#ffffff"/>';
    out += '<polygon points="' + [pt(0, 0), pt(L, T), pt(L, B), pt(0, ch)].join(' ') + '" fill="#efefef"/>';
    out += '<polygon points="' + [pt(cw, 0), pt(R, T), pt(R, B), pt(cw, ch)].join(' ') + '" fill="#f1f1f1"/>';
    out += '<polygon points="' + [pt(L, B), pt(R, B), pt(cw, ch), pt(0, ch)].join(' ') + '" fill="url(#spFl)"/>';
    // parquet: planks run towards the viewer, joints are staggered
    var N = Math.max(8, Math.min(40, Math.round(W / 14))), M = 8, i, j, d = '', d2 = '';
    for (i = 0; i <= N; i++) { d += 'M' + f(L + i * (R - L) / N) + ',' + f(B) + 'L' + f(i * cw / N) + ',' + f(ch); }
    var us = [0]; for (j = 1; j < M; j++) us.push(Math.pow(j / M, 1.7)); us.push(1);
    for (j = 1; j < M; j++) {
      var u = us[j], y = B + (ch - B) * u;
      for (i = 0; i < N; i++) {
        if ((i + j) % 2) continue;
        var xa0 = L + i * (R - L) / N, xb0 = L + (i + 1) * (R - L) / N, xa1 = i * cw / N, xb1 = (i + 1) * cw / N;
        d2 += 'M' + f(xa0 + (xa1 - xa0) * u) + ',' + f(y) + 'L' + f(xb0 + (xb1 - xb0) * u) + ',' + f(y);
      }
    }
    out += '<path d="' + d + '" stroke="#a9814f" stroke-opacity=".55" stroke-width=".8" fill="none"/>';
    out += '<path d="' + d2 + '" stroke="#a9814f" stroke-opacity=".6" stroke-width=".8" fill="none"/>';
    out += '<g stroke="#d9d9d9" stroke-width="1"><line x1="' + f(L) + '" y1="' + f(T) + '" x2="0" y2="0"/><line x1="' + f(R) + '" y1="' + f(T) + '" x2="' + cw + '" y2="0"/></g>';
    out += '<g stroke="#b99461" stroke-width="1"><line x1="' + f(L) + '" y1="' + f(B) + '" x2="0" y2="' + ch + '"/><line x1="' + f(R) + '" y1="' + f(B) + '" x2="' + cw + '" y2="' + ch + '"/></g>';
    out += '<line x1="' + f(L) + '" y1="' + f(B) + '" x2="' + f(R) + '" y2="' + f(B) + '" stroke="#e4e4e4" stroke-width="3"/>';
    svg.setAttribute('viewBox', '0 0 ' + cw + ' ' + ch); svg.setAttribute('width', cw); svg.setAttribute('height', ch);
    svg.innerHTML = out;
  }

  function layout(box, opts) {
    var wall = el('[data-wwall]', box), kind = box.dataset.kind;
    var W = +opts.w || +box.dataset.w || 400, H = +opts.h || +box.dataset.h || 300;
    var img = opts.img !== undefined ? opts.img : box.dataset.img;
    var cw = box.clientWidth || 600, ch = box.clientHeight || 450;
    var ML = 52, MR = 62, MT = 44, MB = 88;
    var aw = Math.max(60, cw - ML - MR), ah = Math.max(60, ch - MT - MB);
    var s = Math.min(aw / W, ah / H), pw = W * s, ph = H * s;
    var left = ML + (aw - pw) / 2, top = MT + (ah - ph) / 2;
    wall.style.cssText = 'left:' + left + 'px;top:' + top + 'px;width:' + pw + 'px;height:' + ph + 'px;';
    if (img) wall.style.backgroundImage = 'url("' + img + '")';
    if (kind === 'paper') { wall.style.backgroundSize = ((+box.dataset.tile || STRIP) * s) + 'px auto'; wall.style.backgroundRepeat = 'repeat'; wall.style.backgroundPosition = 'left top'; }
    else { wall.style.backgroundSize = 'cover'; wall.style.backgroundPosition = 'center'; wall.style.backgroundRepeat = 'no-repeat'; }
    var seam = el('.seams', wall), p = COVER * s;
    seam.style.backgroundImage = 'repeating-linear-gradient(90deg,transparent 0,transparent ' + Math.max(p - 1.5, 1) + 'px,rgba(255,255,255,.95) ' + Math.max(p - 1.5, 1) + 'px,rgba(0,0,0,.35) ' + p + 'px)';
    room(el('.cl', box), cw, ch, left, top, left + pw, top + ph, W);
    // rulers
    var st = steps(Math.max(W, H)), rt = el('[data-rt]', box), rl = el('[data-rl]', box), html = '', v;
    for (v = 0; v <= W + 0.01; v += st) html += '<span style="left:' + (left + v * s) + 'px">' + lab(v) + '</span>';
    rt.style.cssText = 'left:0;top:' + (top - 24) + 'px;width:' + cw + 'px'; rt.innerHTML = html;
    html = '';
    for (v = 0; v <= H + 0.01; v += st) html += '<span style="top:' + (top + ph - v * s) + 'px">' + lab(v) + '</span>';
    rl.style.cssText = 'left:' + (left - 10) + 'px;top:0;height:' + ch + 'px;width:0'; rl.innerHTML = html;
    // dimension lines
    var dw = el('[data-dw]', box), dh = el('[data-dh]', box);
    dw.style.cssText = 'left:' + left + 'px;width:' + pw + 'px;top:' + (top + ph + 22) + 'px';
    dh.style.cssText = 'top:' + top + 'px;height:' + ph + 'px;left:' + (left + pw + 22) + 'px';
    el('[data-lw]', box).textContent = Math.round(W) + ' cm'; el('[data-lh]', box).textContent = Math.round(H) + ' cm';
    box.classList.toggle('strips', !!(el('[data-strips]', box) || {}).checked);
    box.__last = opts; box.__cw = cw; box.__ch = ch;
    if (box.__zoom) box.__zoom.apply();
  }

  // zoom and pan
  function zoom(box) {
    var zin = el('[data-zin]', box), z = 1, tx = 0, ty = 0, MAXZ = 8;
    var api = {
      apply: function () {
        var cw = box.clientWidth, ch = box.clientHeight;
        tx = Math.min(0, Math.max(cw * (1 - z), tx)); ty = Math.min(0, Math.max(ch * (1 - z), ty));
        zin.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')';
        box.classList.toggle('zoomed', z > 1.01);
        var r = el('[data-zr]', box); if (r) r.textContent = (Math.round(z * 10) / 10) + '×';
      },
      to: function (nz, px, py) {
        nz = Math.min(MAXZ, Math.max(1, nz));
        tx = px - (px - tx) * nz / z; ty = py - (py - ty) * nz / z; z = nz;
        if (z <= 1.001) { z = 1; tx = 0; ty = 0; }
        api.apply();
      }
    };
    function center() { return [box.clientWidth / 2, box.clientHeight / 2]; }
    el('[data-zi]', box).addEventListener('click', function () { var c = center(); api.to(z * 1.6, c[0], c[1]); });
    el('[data-zo]', box).addEventListener('click', function () { var c = center(); api.to(z / 1.6, c[0], c[1]); });
    el('[data-zr]', box).addEventListener('click', function () { api.to(1, 0, 0); });
    function local(e) { var r = box.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    box.addEventListener('wheel', function (e) {
      if (!(e.ctrlKey || e.metaKey || z > 1.01)) return;   // keep normal page scrolling unless zooming
      e.preventDefault(); var p = local(e); api.to(z * (e.deltaY < 0 ? 1.18 : 1 / 1.18), p[0], p[1]);
    }, { passive: false });
    box.addEventListener('dblclick', function (e) { if (e.target.closest('.sw,.zc')) return; var p = local(e); api.to(z > 1.01 ? 1 : 2.5, p[0], p[1]); });
    // drag to pan, pinch to zoom
    var pts = {}, last = null, pd = 0;
    box.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.sw,.zc')) return;
      pts[e.pointerId] = [e.clientX, e.clientY];
      var k = Object.keys(pts);
      if (k.length === 2) { pd = Math.hypot(pts[k[0]][0] - pts[k[1]][0], pts[k[0]][1] - pts[k[1]][1]); }
      last = [e.clientX, e.clientY];
      try { box.setPointerCapture(e.pointerId); } catch (x) { /* ignore */ }
    });
    box.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = [e.clientX, e.clientY];
      var k = Object.keys(pts);
      if (k.length === 2) {
        var d = Math.hypot(pts[k[0]][0] - pts[k[1]][0], pts[k[0]][1] - pts[k[1]][1]);
        if (pd) { var r = box.getBoundingClientRect(), cx = (pts[k[0]][0] + pts[k[1]][0]) / 2 - r.left, cy = (pts[k[0]][1] + pts[k[1]][1]) / 2 - r.top; api.to(z * d / pd, cx, cy); }
        pd = d; return;
      }
      if (z > 1.01 && last) { tx += e.clientX - last[0]; ty += e.clientY - last[1]; api.apply(); }
      last = [e.clientX, e.clientY];
    });
    function up(e) { delete pts[e.pointerId]; pd = 0; last = null; }
    box.addEventListener('pointerup', up); box.addEventListener('pointercancel', up);
    box.__zoom = api;
    return api;
  }

  window.__spWM = function (box, opts) { if (box) layout(box, opts || {}); };
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wm]'), function (b) {
      if (b.__i) return; b.__i = 1;
      var t = el('[data-strips]', b);
      if (t) t.addEventListener('change', function () { b.classList.toggle('strips', t.checked); });
      zoom(b);
      layout(b, {});
      if (window.ResizeObserver) new ResizeObserver(function () { layout(b, b.__last || {}); }).observe(b);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
